var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({class:['columns', {['is-' + _vm.gap]: true, 'is-mobile': _vm.isMobile, 'is-desktop': !_vm.isTablet, ' is-multiline': _vm.isMultiLine}]},'div',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }